window.addEventListener("load", function () {
  if (document.getElementById("fecha_inicio")) {
    document.getElementById("fecha_inicio").type = "text";
    document
      .getElementById("fecha_inicio")
      .addEventListener("blur", function () {
        document.getElementById("fecha_inicio").type = "text";
      });

    document
      .getElementById("fecha_inicio")
      .addEventListener("focus", function () {
        document.getElementById("fecha_inicio").type = "date";
      });
  }
  if (document.getElementById("fecha_fin")) {
    document.getElementById("fecha_fin").type = "text";
    document.getElementById("fecha_fin").addEventListener("blur", function () {
      document.getElementById("fecha_fin").type = "text";
    });

    document.getElementById("fecha_fin").addEventListener("focus", function () {
      document.getElementById("fecha_fin").type = "date";
    });
  }
});
